import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import { withRouter } from "react-router-dom";
import * as _ from "lodash";

import withAuthorization from '../auth/withAuthorization';
import {
   fetchGamesByUser,
   fetchMultiplePrivateGames,
   fetchMultiplePublicGames,
   fetchSampleGames,
   fetchUserGameStates,
   selectGame
} from "../../actions";
import { AUTHOR_ID, GAME_STATUS, GAME_STATUS_COMPLETED, IS_PRIVATE, PUBLIC } from "../../constants/Game";
import { AuthoredGameListing } from "./GameListItem";
import { PlayedGameListing } from "./GameEntryListItem";

import '../../global.css';
import './HomePage.css';
import { CreateNewHuntButton } from "./CreateNewHuntButton";
import { LATLON_QUERY } from "../../constants/ActionTypes";

/**
 * The List of games displayed on our main index for the Create Treasure Hunt App.
 *
 * Shows
 * (1) Hunts played
 * (2) Public Games Authored
 * (3) Private Games Authored
 *
 * Future:
 * Add a personal profile component for a right hand column
 */
class HomePage extends Component {
   constructor(props) {
      super(props);

      this.state = {
         fetchedMissingGameDataOnce: false,
      };

      this.onGameSelect = this.onGameSelect.bind(this);
   }

   componentDidMount() {
      fetchSampleGames();
      fetchUserGameStates(this.uid());

      const latLon = parseLatLon(this.props.location.search);

      if (!!latLon) {
         this.props.setLatLon(latLon);
      }
   }

   /*
      From the game-state-collection, return all the give user's augmented gameStates, as an array, while
      also fetching any missing games.
   */
   myGameEntries(allGameStates, games) {
      const uid = this.uid();
      if (!allGameStates || !uid) {
         return null;
      }
      const myGameStates = allGameStates.byUser[uid];

      let augmentedGameStates = {};
      let missingPublicGameIds = [];
      let missingPrivateGameIds = [];

      _.forEach(myGameStates, function (value, key) {
         // if we have a game, combine the fields
         if (!!games[key]) {
            augmentedGameStates[key] = {...value, ...games[key]}
         } else {
            // otherwise, just take game state data
            augmentedGameStates[key] = value;
            // log missing game id so we can fetch it
            if (value[IS_PRIVATE]) {
               missingPrivateGameIds.push(key)
            } else {
               missingPublicGameIds.push(key)
            }
         }
      });

      // call action to retrieve missing games (public and private)
      if (missingPublicGameIds.length > 0) {
         fetchMultiplePublicGames(missingPublicGameIds);
      }
      if (missingPrivateGameIds.length > 0) {
         fetchMultiplePrivateGames(missingPrivateGameIds);
      }

      return _.values(augmentedGameStates);
   }

   onGameSelect(game) {
      this.props.selectGame(game);
      this.props.history.push(`/games/${game.id}`);
   }

   isOtherUser() {
      return !!this.props.match.params.id;
   }

   uid() {
      // came to page with specific user
      // todo: test that only admin user can execute this page.
      const overrideId = this.props.match.params.id;
      if (!!overrideId) {
         return overrideId
      }

      return this.props.user
         ? this.props.user.id
         : this.props.authUser ? this.props.authUser.uid : null;
   }

   // helper to grab the id
   gameId() {
      return this.props.match.params.id;
   }

   nameOverride() {
      return this.props.match.params.name;
   }


   render() {
      const {gameMap, gameStates, user} = this.props;
      const uid = this.uid();

      if (!uid) {
         return <div> Loading user... </div>
      }

      if (!gameMap) {
         const userForFetch = (!!this.props.user && !this.isOtherUser()) ? this.props.user : { id : uid };
         this.props.fetchGames(userForFetch);
         return <div> Loading authored games... </div>
      }

      if (!gameStates) {
         return <div> Loading game states... </div>
      }

      // myGameEntries will further load missing games.
      const myGames = this.myGameEntries(gameStates, gameMap);
      const activeGames = [];
      const completedGames = [];

      myGames.forEach ( gameState => {
         if (gameState[GAME_STATUS] === GAME_STATUS_COMPLETED) {
            completedGames.push(gameState);
         } else {
            activeGames.push(gameState);
         }
      });

      const heading = possessiveNameFromUser(user, this.nameOverride()) + " HUNTS";
      const hasCompletedGames = completedGames.length > 0;

      const gamesAuthored = gameMap ? _.values(gameMap) : null;
      const byUserPublic = (game) => game[AUTHOR_ID] === uid && game[PUBLIC];
      const byUserPrivate = (game) => game[AUTHOR_ID] === uid && !game[PUBLIC];
      const byIsSample = (game) => game.isSample;

      const authoredPublic = gamesAuthored ? gamesAuthored.filter(byUserPublic) : null;
      const authoredPrivate = gamesAuthored ? gamesAuthored.filter(byUserPrivate) : null;
      const samples = gamesAuthored ? gamesAuthored.filter(byIsSample) : null;
      const hasPublic = !!authoredPublic && authoredPublic.length > 0
      const hasPrivate = !!authoredPrivate && authoredPrivate.length > 0


      const pronoun = this.isOtherUser() ? "they're" : "you're";
      const playedGamesTitle = "Games " + pronoun + " playing";

      return (
         <div className="main">

            <div className="mostly-opaque-white home-div-spacing">

               <div className="col-sm-10 col-xs-12">

                  <h1 className="black HomePage-left-margin-above-bootstrap-list-half" >{heading}</h1>

                  {!this.isOtherUser() &&
                     <div>
                        <p className="secondary-text HomePage-left-margin-above-bootstrap-list big-bottom-margin ">
                           Your starting point for authoring and editing hunts and your game play lists.
                        </p>

                        <p className="secondary-text HomePage-left-margin-above-bootstrap-list big-bottom-margin ">
                           NOTE: You can edit your hunts here both using the app on your phone, or on the web
                           with any computer at <b>https://create.ourtreasurehunt.com</b>
                        </p>
                     </div>}

                  <PlayedGameListing
                     title={playedGamesTitle}
                     gameEntries={activeGames}
                  />

                  {hasCompletedGames &&
                     <PlayedGameListing
                        title="Completed Games"
                        gameEntries={completedGames}
                     />
                  }
               </div>

               {!this.isOtherUser() &&
               <div className="top-margin">
                  <CreateNewHuntButton
                     buttonText="Create New Hunt"
                     linkTo="/games/new"
                  />
               </div>}

               <div className="col-sm-10 col-xs-12 top-margin">

               {hasPublic &&
               <AuthoredGameListing
                  title="Authored Public Hunts"
                  gameList={authoredPublic}
                  onGameSelect={this.onGameSelect}
                  canEdit={true}
               />
               }

               {hasPrivate &&
               <AuthoredGameListing
                  title="Authored Private Hunts"
                  gameList={authoredPrivate}
                  onGameSelect={this.onGameSelect}
                  canEdit={true}
               />
               }
                  {!this.isOtherUser() &&
                  <div>
                     {!hasPublic && !hasPrivate &&
                     <div className="small-top-margin small-bottom-margin ">
                        <p className="bottom-margin HomePage-left-margin-above-bootstrap-list">
                           You've authored no hunts. Consider creating one!
                        </p>
                        <p className="big-top-margin HomePage-left-margin-above-bootstrap-list">
                           Check out these sample hunts to see how a finished hunt fits together.
                        </p>
                     </div>
                     }

                     <AuthoredGameListing
                        title="Sample Hunts"
                        gameList={ samples }
                        onGameSelect={this.onGameSelect}
                        canEdit={false}
                     />
                  </div> }
               </div>
            </div>
         </div>
      );
   }
}

/*
 Supports passing in location as part of query string.  Either like:
   ?seed=44.9,-93.467   or
   ?getp=490l346
 Note that in the second form the numbers will be divided by 100 and are separated by an l.  The first number has 45 added to it,
 and the second number get a sign switch and then has 90 subtracted from it.
 */
export function parseLatLon(queryStr) {
   if (!queryStr) return null;

   const hasSeed = queryStr.indexOf("?seed=") >= 0;
   const hasGen = queryStr.indexOf("?getp") >= 0;

   if (!(hasSeed || hasGen) || queryStr.length < 9) return null;

   const latLon = queryStr.slice(6);

   const sep = hasSeed ? "," : "l";
   const div = latLon.indexOf(sep);

   if (div < 1 || div > latLon.length-2) return null;

   let lat;
   let lon;

   const latStr = latLon.slice(0,div)
   const lonStr = latLon.slice(div+1);
   if (hasSeed) {
      lat = parseFloat(latStr);
      lon = parseFloat(lonStr);
   } else {
      lat = parseFloat(latStr)/100 + 45;
      lon = -parseFloat(lonStr)/100 - 90;
   }

   if (isNaN(lat) || isNaN(lon)) return null;
   if (lat < -80 || lat > 80 ) return null;

   return { coords: { latitude: lat, longitude: lon } };
}

export function possessiveNameFromUser(user, override = null) {

   if (!!override) {
      return override.replace("+"," ") + "'s";
   }

   if (!user) return "Your";

   if (!user.name) {
      return "Your";
   } else {
      return user.name + "'s";
   }
}

// pull in app-wide (redux) state as props
function mapStateToProps(state) {

   return {
      gameMap: state.games,
      user: state.userState.user,
      authUser: state.sessionState.authUser,
      isAdmin: state.sessionState.isAdmin,
      gameStates: state.gameStates
   };
}

// Dispatch some actions plus get their references as props
function mapDispatchToProps(dispatch) {

   return bindActionCreators({
      selectGame: selectGame,
      fetchGames: fetchGamesByUser,
      setLatLon: (latLon) => dispatch({ type: LATLON_QUERY, payload: latLon })
   }, dispatch)
}

// Check for non-null authenticated user
const authCondition = (authUser) => !!authUser;

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, mapDispatchToProps),
   withRouter
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/yourpage/HomePage.js